__turbopack_context__.v({
  "container": "Overview-module-scss-module__VlE6lG__container",
  "description": "Overview-module-scss-module__VlE6lG__description",
  "mainContainer": "Overview-module-scss-module__VlE6lG__mainContainer",
  "productList": "Overview-module-scss-module__VlE6lG__productList",
  "title": "Overview-module-scss-module__VlE6lG__title",
  "tooltip": "Overview-module-scss-module__VlE6lG__tooltip",
  "videoContainer": "Overview-module-scss-module__VlE6lG__videoContainer",
  "videoDate": "Overview-module-scss-module__VlE6lG__videoDate",
});
